import React, { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { ContentProvider } from './context/ContentContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollProgress from './components/ScrollProgress';
import Preloader from './components/Preloader';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogsPage from './pages/BlogsPage';
import BlogPost from './pages/BlogPost';
import ServicesPage from './pages/ServicesPage';
import GalleryPage from './pages/GalleryPage';
import AwardsPage from './pages/AwardsPage';
import TestimonialsPage from './pages/TestimonialsPage';
import BooksPage from './pages/BooksPage';
import SelfTalkPage from './pages/SelfTalkPage';
import EventsPage from './pages/EventsPage';
import EventDetail from './pages/EventDetail';
import CoursesPage from './pages/CoursesPage';
import CourseDetail from './pages/CourseDetail';
import CourseRegister from './pages/CourseRegister';
import ConsultantPage from './pages/ConsultantPage';
import ConsultationsPage from './pages/ConsultationsPage';
import StudentLogin from './pages/StudentLogin';
import PopupManager from './components/PopupManager';

function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  // Standalone landing pages render without the site chrome (header/footer).
  const bare = location.pathname.startsWith('/register/');

  return (
    <>
      {loading && <Preloader onComplete={() => setLoading(false)} />}
      <div className="App">
        <ScrollProgress />
        {!bare && <Header />}
        <main key={location.pathname} className="page-transition">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blogs" element={<BlogsPage />} />
            <Route path="/tag/:tag" element={<BlogsPage />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/awards" element={<AwardsPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/books" element={<BooksPage />} />
            <Route path="/self-talk" element={<SelfTalkPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/courses/:slug" element={<CourseDetail />} />
            <Route path="/register/:slug" element={<CourseRegister />} />
            <Route path="/consultation" element={<ConsultationsPage />} />
            <Route path="/cons/:slug" element={<ConsultantPage />} />
            <Route path="/student/login" element={<StudentLogin />} />
          </Routes>
        </main>
        {!bare && <Footer />}
        <ScrollToTop />
        {!bare && <PopupManager />}
      </div>
    </>
  );
}

function App() {
  return (
    <ContentProvider>
      <AppContent />
    </ContentProvider>
  );
}

export default App;
